enum SETTINGS_LIST_THEME {
  DEFAULT = 'default',
  DEVICE_SETTINGS = 'device-settings',
}

export {
  SETTINGS_LIST_THEME,
};
